import { NotesRepositoryImplementation } from '../infrastructure/notes-repository-implementation'


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new NotesRepositoryImplementation();
const CACHE_PREFIX = 'notes';

async function getAllNotes(uid: string, cid: string | null) {
    const cacheKey = `${CACHE_PREFIX}-list-${uid}-${cid}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) {
        console.log(`Returning all notes for ${uid}/${cid} from cache`);
        return cached;
    }

    const response = await repo.getNotes(uid, cid).toPromise();
    const data = response.data;
    if (data.data.length === 0) return data;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function getNoteDocuments(uid: string, cid: string | null, page = 1, limit = 20) {
    const cacheKey = `${CACHE_PREFIX}-docs-${uid}-${cid}-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const response = await repo.getNoteDocuments(uid, cid, page, limit).toPromise();
    const data = response.data;
    if (data.data.length > 0) {
        cacheManager.setItem(cacheKey, data);
    }
    return data;
}

async function getNoteDocumentItems(uid: string, cid: string | null, noteId: number) {
    const response = await repo.getNoteDocumentItems(uid, cid, noteId).toPromise();
    return response.data;
}

async function createNote(uid: string, cid: string | null, data: any) {
    const response = await repo.createNote(uid, cid, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

export { getAllNotes, createNote, getNoteDocuments, getNoteDocumentItems };
